<template>
  <div>
    <b-notification :has-icon="true" :icon="'shield'" :closable="false">
      <strong>
        {{ $t('compCarbonFormsSurveyPreamble.preamble-title') }}
      </strong>
      <br />
      {{ $t('compCarbonFormsSurveyPreamble.preamble-1') }}
      <br /><br />
      {{ $t('compCarbonFormsSurveyPreamble.preamble-2') }}
      <br /><br />
      {{ $t('compCarbonFormsSurveyPreamble.preamble-3') }}
      <br /><br />
      <b-collapse
        :open="false"
        position="is-bottom"
        aria-id="contentIdForA11y1"
      >
        <a
          class="link"
          slot="trigger"
          slot-scope="props"
          aria-controls="contentIdForA11y1"
        >
          <b-icon :icon="!props.open ? 'caret-down' : 'caret-up'"> </b-icon>
          {{
            !props.open
              ? $t('compCarbonFormsSurveyPreamble.preamble-16')
              : $t('compCarbonFormsSurveyPreamble.preamble-17')
          }}
        </a>
        {{ $t('compCarbonFormsSurveyPreamble.preamble-4') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-5') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-6') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-7') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-8') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-9') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-10') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-11') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-12') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-13') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-14') }}
        <br /><br />
        {{ $t('compCarbonFormsSurveyPreamble.preamble-15') }}
      </b-collapse>
    </b-notification>
    <b-notification
      v-if="surveyMessage"
      :has-icon="true"
      :icon="'info'"
      :closable="false"
    >
      <strong>
        {{ $t('compCarbonFormsSurveyPreamble.lab-message') }}
      </strong>
      <br />
      {{ surveyMessage }}
    </b-notification>
    <br />
    <div class="columns">
      <div class="column">
        <b-button
          class="button is-fullwidth"
          :disabled="true"
          icon-left="angle-double-left"
        >
          {{ $t('previous') }}
        </b-button>
      </div>
      <div class="column">
        <b-button
          class="button is-fullwidth is-primary"
          @click="$emit('submit')"
          icon-right="angle-double-right"
        >
          {{ $t('start') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preamble',
  props: {
    surveyMessage: {
      type: String,
      required: true
    }
  }
}
</script>
